<template>
    <div class="trash-alert-main">
      <transition name="opacity">
        <div class="cover" v-if="show"></div>
      </transition>
      <transition name="box">
        <div class="box" v-if="show">
          <div class="header">
            {{title}}
          </div>
          <i class="close iconfont iconx" @click="close"></i>
          <div class="content" v-html="content"></div>
          <div class="btn">
            <button class="action" @click="confirm">{{buttonName}}</button>
            <button @click="close" v-if="!hideCloseBtn">取消</button>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
export default {
  name: 'alert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    buttonName: {
      type: String,
      default: '确认'
    },
    content: {
      type: String,
      default: ''
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      animation: false
    };
  },
  watch: {
    show(val) {
      this.animation = val
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
<style lang="scss" scoped>
  .trash-alert-main {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
    }
    .box {
      width: 446px;
      height: 212px;
      background: #fff;
      border-radius: 4px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      // transform: translate(-50%, -50%);
      .close {
        font-size: 20px;
        color: #404040;
        font-weight: 600;
        position: absolute;
        top: 34px;
        right: 33px;
        cursor: pointer;
      }
      .header {
        height: 72px;
        // border-bottom: 1px solid #E8E8E8;
        font-size: 16px;
        font-weight: 600;
        color: #404040;
        line-height: 72px;
        padding-left: 32px;
      }
      .content {
        // width: 360px;
        line-height: 24px;
        padding: 0 32px;
        font-size: 14px;
        color: #404040;
      }
      .btn {
        text-align: right;
        position: absolute;
        bottom: 25px;
        right: 28px;
        button {
          width: 92px;
          height: 38px;
          border: 1px solid #979797;
          border-radius: 2px;
          font-size: 14px;
          color: #909090;
          background: #fff;
          &.action {
            background: #FF6644;
            border-color: #FF6644;
            color: #fff;
            margin-left: 16px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>